/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const SET_APPLICATION_MODE = 'app/Application/SET_APPLICATION_MODE';
export const SET_DEBUG_LEVEL = 'app/Application/SET_DEBUG_LEVEL';
export const SET_TRANSLATION_MODE = 'app/Application/SET_TRANSLATION_MODE';
export const LOAD_APPLICATION = 'app/Application/LOAD_APPLICATION';
export const SET_LOAD_PLAN_FROM_LINK_ERROR = 'app/Application/SET_LOAD_PLAN_FROM_LINK_ERROR';
export const SET_LOAD_LOCAL_PLAN_ERROR = 'app/Application/SET_LOAD_LOCAL_PLAN_ERROR';
export const SET_SAVE_ERROR = 'app/Application/SET_SAVE_ERROR';
export const SHOW_PRICE_DIFFERENCE_DIALOG = 'app/Application/SHOW_PRICE_DIFFERENCE_DIALOG';
export const HIDE_PRICE_DIFFERENCE_DIALOG = 'app/Application/HIDE_PRICE_DIFFERENCE_DIALOG';
export const PLAN_LOADING = 'app/Application/PLAN_LOADING';
export const RESET_DIALOGS = 'app/Application/RESET_DIALOGS';
export const DISPLAY_VIRTUAL_KEYBOARD = 'app/Application/DISPLAY_VIRTUAL_KEYBOARD';
export const DISABLE_PRICE_ANIMATION = 'app/Application/DISABLE_PRICE_ANIMATION';
export const SHOW_PLAN_SAVED_DIALOG = 'app/Application/SHOW_PLAN_SAVED_DIALOG';
export const CLOSE_PLAN_SAVED_DIALOG = 'app/Application/CLOSE_PLAN_SAVED_DIALOG';
export const SHOW_NEW_FEATURES_DIALOG = 'app/Application/SHOW_NEW_FEATURES_DIALOG';
export const SHOW_NEW_FEATURES_TOAST = 'app/Application/SHOW_NEW_FEATURES_TOAST';
export const DISPLAY_PRINT_FORMAT = 'app/Application/DISPLAY_PRINT_FORMAT';
export const SET_IPEXGALLERY_MODE = 'app/Application/SET_IPEXGALLERY_MODE';
export const SET_UPPTACKA_MODE = 'app/Application/SET_UPPTACKA_MODE';
export const SET_KIOSK_PRINT_MODE = 'app/Application/SET_KIOSK_PRINT_MODE';
export const SET_IDLE_TIME = 'app/Application/SET_IDLE_TIME';

// Application modes
export const KIOSK = 'kiosk';
export const IFRAME = 'iframe';
export const NORMAL = 'normal';
